import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface QuestionnaireConditionalSectionProps {
  condition: boolean;
  children: ReactNode;
  className?: string;
}

export function QuestionnaireConditionalSection({
  condition,
  children,
  className,
}: QuestionnaireConditionalSectionProps) {
  if (!condition) return null;

  return (
    <div
      className={cn(
        "space-y-2 rounded-lg border border-slate-200/70 bg-slate-50 px-4 py-4",
        className,
      )}
    >
      {children}
    </div>
  );
}
